import React from 'react';
import cn from 'classnames';

export interface CaptionProps {
  size?: 'default' | 's';
  weight?: 'medium' | 'bold';
  children: React.ReactNode;
  as?: React.ElementType;
  className?: string;
  htmlFor?: string;
  id?: string;
}

export const Caption: React.FC<CaptionProps> = ({
  size = 'default',
  weight = 'medium',
  children,
  as: Component = 'span',
  className,
  htmlFor,
  id,
}) => {
  const classes = cn(
    {
      'text-ds-caption': size === 'default',
      'text-ds-caption-s': size === 's',
      'font-medium': weight === 'medium',
      'font-bold': weight === 'bold',
    },
    className,
  );

  return (
    <Component className={classes} {...(htmlFor && { htmlFor })} {...(id && { id })}>
      {children}
    </Component>
  );
};

export default Caption;
